import React, { Component } from "react";
import PropTypes from "prop-types";

import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { Modal, Button, Toastr } from "arv-reactcomponents";
import Analytics from "../../../analytics";

import AddAddress from "../../ReturnComponent/AddAddress";
import AddressList from "../../AddressList";
import SelectedAddressText from "../SelectedAddressText";
import { Checkout } from "npmlinks-constants";
import Event from "../../../analytics/eventFactory";

@withRouter
@inject("AddressStore", "CheckoutStore", "CodStore")
@observer
class SelectedAddressBlock extends Component {
  static ShowToastr(message = Checkout.CHECKOUT_MESSAGES.ERROR_MESSAGE) {
    Toastr.showToastr({
      className: "nwc-toastr-list-danger nw-toastr",
      message,
      timeout: 3000,
    });
  }
  constructor() {
    super();
    this.state = {
      addressObject: {},
      addressId: "",
      edit: false,
      loading: false,
      loader: false,
      currentView: "addressList",
      backButton: false,
    };
    this.showSavedAddressModal = this.showSavedAddressModal.bind(this);
    this.closeSavedAddressModal = this.closeSavedAddressModal.bind(this);
    this.showAddAddressModal = this.showAddAddressModal.bind(this);
    this.closeAddAddressModal = this.closeAddAddressModal.bind(this);
    this.showPincodeScreen = this.showPincodeScreen.bind(this);
    this.onAddressSave = this.onAddressSave.bind(this);
    this.setNewAddress = this.setNewAddress.bind(this);
    this.setAddressDefault = this.setAddressDefault.bind(this);
    this.removeAddress = this.removeAddress.bind(this);
    this.showEditAddress = this.showEditAddress.bind(this);
    this.previous = this.previous.bind(this);
    this.makeAddAddressPristine = this.makeAddAddressPristine.bind(this);
  }

  get selectedAddress() {
    const { shippingAddress } = this.props.CheckoutStore;
    return shippingAddress;
  }

  showSavedAddressModal(heading) {
    this.setState({ loader: true });
    this.props.AddressStore.getUserAddresses().then(() => {
      this.setState({ loader: false });
    });
    this.props.AddressStore.setSavedAddressModal(true, heading);
    Analytics.trackEvent({
      action: Event.action.Change_address_click,
      category: window.pageType,
      interaction: true,
    });
  }

  makeAddAddressPristine(){
    this.setState({
      currentView: "addAddress",
      addressObject: {},
      addressId: "",
      edit: false,
      backButton: true,
      loading: false,
    });
  }

  showAddAddressModal(heading, buttonText) {
    this.props.AddressStore.setSavedAddressModal(false);
    this.props.AddressStore.setAddAddressModal(true, heading, buttonText);
    this.makeAddAddressPristine();
    Analytics.trackEvent({
      action: Event.action.Add_a_new_address_click,
      category: window.pageType,
      interaction: true,
    });
  }

  closeSavedAddressModal() {
    this.props.AddressStore.setSavedAddressModal(false);
  }

  closeAddAddressModal() {
    this.props.AddressStore.setAddAddressModal(false);
    this.makeAddAddressPristine();
  }

  showPincodeScreen() {
    this.props.AddressStore.showPincodeScreen(true);
    Analytics.trackEvent({
      action: Event.action.Change_pincode_click,
      category: window.pageType,
      interaction: true,
    });
  }

  setNewAddress(paramid, address) {
    const { id: addressId, pincode } = address;
    const { shippingAddress = {} } = this.props.CheckoutStore;
    const { id } = { ...shippingAddress };
    if (id === addressId) {
      this.props.AddressStore.setSavedAddressModal(false);
      return null;
    }
    this.props.AddressStore.setCurrentPincode(pincode);
    this.setState({ loader: true });

    this.props.CheckoutStore.updateCart({ addressId }).then(
      () => {
        this.props.CheckoutStore.clearPresets();
        this.setState({ loader: false });
        this.props.CheckoutStore.setAddressId(addressId);
        this.props.AddressStore.setSavedAddressModal(false);
      },
      () => {
        this.setState({ loader: false });
      },
    );
    this.props.CodStore.setCodVerified();
    Analytics.trackEvent({
      action: Event.action.Change_address_selected,
      category: window.pageType,
      interaction: true,
    });
    return null;
  }

  onAddressSave(addAddressDetails, addressId, edit) {
    Analytics.trackEvent({
      action: Event.action.Add_new_deliver_click,
      category: window.pageType,
      interaction: true,
    });
    let promise;
    if (edit && addressId) {
      promise = this.props.AddressStore.editAddress(
        addAddressDetails,
        addressId,
        true,
      );
    } else {
      promise = this.props.AddressStore.addAddressCall(
        addAddressDetails,
        true,
        true,
      );
    }
    this.setState({ loading: true });
    promise
      .then(res => {
        if (edit) {
          this.makeAddAddressPristine();
          this.props.AddressStore.setAddAddressModal(false, null, null, false);
          this.props.AddressStore.setSavedAddressModal(true);
          return;
        }
        this.props.CheckoutStore.clearPresets();
        const [addressId] = Object.keys(res);
        Analytics.trackEvent({
          action: Event.action.Add_address_success,
          category: window.pageType,
        });
        this.props.AddressStore.setCurrentPincode(res[addressId].pincode);
        this.props.CheckoutStore.setAddressId(addressId);
        this.props.CheckoutStore.updateCart({ addressId })
          .then(() => {
            this.setState({ loading: false });
            if (this.props.AddressStore.continueToCheckout) {
              this.props.history.push(
                Checkout.CHECKOUT_ROUTES.SUPPORTED.payment,
              );
              Analytics.trackEvent({
                category: window.pageType,
                action: Event.action.Checkout_Step_1_Done,
              });
            }
            this.props.AddressStore.setAddAddressModal(
              false,
              null,
              null,
              false,
            );
          })
          .catch(() => {
            this.setState({ loading: false });
          });
        this.props.CodStore.setCodVerified();
      })
      .catch(() => {
        SelectedAddressBlock.ShowToastr();
        Analytics.trackEvent({
          action: Event.action.Add_address_failure,
          category: window.pageType,
        });
        this.setState({ loading: false });
      });
  }

  setAddressDefault(addressId) {
    this.props.AddressStore.setAddressDefault(addressId).then(
      () => {
        this.props.AddressStore.getUserAddresses(true);
      },
      () => {
        SelectedAddressBlock.ShowToastr();
      },
    );
  }

  removeAddress(addressId) {
    this.props.AddressStore.removeAddress(addressId).then(
      () => {
        this.props.AddressStore.getUserAddresses(true);
      },
      () => {
        SelectedAddressBlock.ShowToastr();
      },
    );
  }

  showEditAddress(addressObject) {
    this.showAddAddressModal(
      Checkout.CHECKOUT_MESSAGES.ADDRESS.NEW_DELIVERY_ADDRESS_TITLE,
      Checkout.CHECKOUT_BUTTON_TEXTS.DELIVER_HERE,
    );
    this.setState({
      currentView: "addAddress",
      addressObject,
      addressId: addressObject.id,
      edit: true,
      backButton: true,
    });
  }

  previous(e) {
    if (e) e.preventDefault();
    const { currentView } = this.state;
    if (currentView === "addAddress") {
      this.closeAddAddressModal();
      this.showSavedAddressModal(
        Checkout.CHECKOUT_MESSAGES.ADDRESS.CHANGE_ADDRESS_TITLE,
      );
      this.setState({
        currentView: "addressList",
        addressObject: {},
        addressId: "",
        edit: false,
        backButton: false,
      });
    }
  }

  render() {
    const { userAddresses } = this.props.AddressStore;
    const { pincode } = this.props.CheckoutStore;
    const { addressObject, addressId, edit, backButton } = this.state;
    return (
      <div className="nw-selectedaddressblock-wrapper">
        <div className="nw-selectedaddressblock-header">
          <div>
            <span className="nw-selectedaddressblock-text">
              {Checkout.CHECKOUT_MESSAGES.ADDRESS.PINCODE_TITLE}
            </span>
            <Button
              onClick={this.showPincodeScreen}
              className="nw-selectedaddressblock-pincode"
            >
              {pincode}
            </Button>
          </div>
          {!this.selectedAddress && (
            <Button
              className="nw-selectedaddressblock-cta"
              onClick={() =>
                this.showAddAddressModal(
                  Checkout.CHECKOUT_MESSAGES.ADDRESS.NEW_DELIVERY_ADDRESS_TITLE,
                  Checkout.CHECKOUT_BUTTON_TEXTS.DELIVER_HERE,
                )
              }
            >
              {Checkout.CHECKOUT_BUTTON_TEXTS.ADD_ADDRESS}
            </Button>
          )}
        </div>
        {this.selectedAddress && (
          <div className="nw-selectedaddressblock-address">
            <div className="nw-selectedaddressblock-topbar">
              <span className="nw-selectedaddressblock-addresstext">
                {Checkout.CHECKOUT_MESSAGES.ADDRESS.DELIVERY_ADDRESS_TITLE}
              </span>
              <Button
                className="nw-selectedaddressblock-cta"
                onClick={() =>
                  this.showSavedAddressModal(
                    Checkout.CHECKOUT_MESSAGES.ADDRESS.CHANGE_ADDRESS_TITLE,
                  )
                }
              >
                {Checkout.CHECKOUT_BUTTON_TEXTS.CHANGE_ADDRESS}
              </Button>
            </div>
            <SelectedAddressText.component
              className="nw-selectedaddressblock-textwrap"
              value={this.selectedAddress}
            />
          </div>
        )}
        <Modal
          isOpen={this.props.AddressStore.isSavedAddressOpen}
          onClose={this.closeSavedAddressModal}
          className="nw-selectedaddressblock-modal"
        >
          <AddressList.component
            addresses={userAddresses}
            addAddress={this.showAddAddressModal}
            onAddressSelection={this.setNewAddress}
            onEditClick={this.showEditAddress}
            onRemoveAddress={this.removeAddress}
            doNotShowRemoveAddress
            onSetAddressDefault={this.setAddressDefault}
            showLocalLoader={this.state.loader}
          />
        </Modal>
        <Modal
          isOpen={this.props.AddressStore.isAddAddressOpen}
          onClose={this.closeAddAddressModal}
          className="nw-selectedaddressblock-addaddress"
        >
          <AddAddress.component
            onAddressSave={this.onAddressSave}
            edit={edit}
            showLocalLoader={this.state.loading}
            editableAddress={addressObject}
            previous={this.previous}
            showBackButton={backButton}
          />
        </Modal>
      </div>
    );
  }
}
SelectedAddressBlock.defaultProps = {};
SelectedAddressBlock.wrappedComponent.propTypes = {
  CheckoutStore: PropTypes.shape({
    pincode: PropTypes.string.isRequired,
    shippingAddress: PropTypes.shape({}).isRequired,
  }).isRequired,
  AddressStore: PropTypes.shape({
    userAddresses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentPincode: PropTypes.string.isRequired,
    isAddAddressOpen: PropTypes.bool.isRequired,
    isSavedAddressOpen: PropTypes.bool.isRequired,
    showPincodeScreen: PropTypes.func.isRequired,
    setSavedAddressModal: PropTypes.func.isRequired,
    setAddAddressModal: PropTypes.func.isRequired,
    setAddressDefault: PropTypes.func,
    removeAddress: PropTypes.func,
  }).isRequired,
  CodStore: PropTypes.shape({
    setCodVerified: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("AddressStore", "CheckoutStore", "CodStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: SelectedAddressBlock.wrappedComponent,
  component: SelectedAddressBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutComponents/SelectedAddressBlock/index.js